var exports = {
  "kL": "x234b8571--e4b7ef--container",
  "Cf": "x234b8571--e4b7ef--side",
  "Y$": "x234b8571--e4b7ef--slider-item",
  "E2": "x234b8571--e4b7ef--callback",
};

module.exports = exports;
